import React from 'react';
import { themeGreen } from '../../theme';
import Layout from '../../components/Layout/Layout';
import Fade from '@material-ui/core/Fade';
import Rating from '@material-ui/lab/Rating';
import LoginModal from '../../containers/LoginModal/LoginModal';
import { Button, makeStyles, Typography, Box, Container, TextField, Chip, FormHelperText } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { useForm } from "react-hook-form";
import { useSnackbar } from 'notistack';

// filepond
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
// type
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';



// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImageValidateSize);



const useStyles = makeStyles(theme => ({
    Container: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    MainWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: '600px',
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(10),
        [theme.breakpoints.down('md')]: {
            maxWidth: 'initial'
        }
    },
    ProductWrapper: {
        marginTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center'
    },
    ProductAvatar: {
        width: '80px',
        height: '80px',
        flexShrink: 0,
        borderRadius: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img' : {
            width: 'auto',
            height: '100%'
        }
    },    
    ProductInfo: {
        marginLeft: theme.spacing(2)
    },
    LightText : {
        fontWeight: 100
    },
    QuestionText : {
        fontSize: '18px',
        fontWeight: 500,
        marginBottom: theme.spacing(2),
    },
    QuestionTextExtra : {
        marginLeft: theme.spacing(1),
        color: theme.palette.text,
        fontSize: '12px'
    },
    FormWrapper: {
    },
    RatingWidget: {        
        fontSize: '2.5rem'
    },
    RatingWrapper : {
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
    },
    Form : {
        marginTop: theme.spacing(8),
        width: '100%'
    },
    Title: {
        width: '100%',
        fontSize: '30px',
        fontWeight: 500,        
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px'            
        }
    },
    SubmitBtn: {
        marginTop: '40px'
    },
    ActionsWrapper: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    previewChip: {
        minWidth: 160,
        maxWidth: 210
    },
    FileAreaText : {
        fontSize: '16px'
    },
    FileAreaIcon: {
        width: '40px'
    }
}));

function ReviewForm(props) {    
    const STATIC_URL_1 = 'https://static.aastatic.com.ar/';
    const STATIC_URL_2 = 'https://static2.aastatic.com.ar/';
    const LABELS = {        
        1: 'Muy Malo',
        2: 'Malo',
        3: 'Bueno',
        4: 'Muy Bueno',
        5: 'Excelente'        
    };
    const classes = useStyles(themeGreen);
    const { enqueueSnackbar } = useSnackbar();
    const { register, getValues, handleSubmit, watch, errors, setValue } = useForm();
    const [G_USER_ID, setUserId] = React.useState(0);
    const [hover, setHover] = React.useState(-1); 
    const [loading, setLoading] = React.useState(false);    
    const [loginOpen, setLoginOpen] = React.useState(false);
    const [rubroImg, setRubroImg] = React.useState(null);    
    const [reviewImages, setReviewImages] = React.useState([]);      
    const [imagesToUpload, setImagesToUpload] = React.useState([]);    
    const [marca, setMarcaNombre] = React.useState('');
    const [modelo, setModeloNombre] = React.useState('');    
    const [rubro, setRubroNombre] = React.useState({
        gen: '',
        nombre: ''
    });
    const [param_r2, setParamR2] = React.useState(props.match.params['rubro2']);
    const [param_mod, setParamMod] = React.useState(props.match.params['model']);
    const [loginResult, setLoginResult] = React.useState(null);
    const refForForm = React.useRef(null);
    
    React.useEffect(() => {
        if (loginResult && loginResult.user_id) {
            handleSubmit(onSubmit)()
        }
    }, [loginResult])
    

    React.useEffect(() => {
        window.scrollTo(0, 0);
        register({ name: "year" }, 
                    { 
                      minLength: { value: 4, message: 'El año debe estar en formato yyyy' }, 
                      maxLength: { value: 4, message: 'El año debe estar en formato yyyy'},
                      max: { value: new Date().getFullYear(), message: `El año no puede ser superior a ${new Date().getFullYear()}` },
                      min: { value: 1900, message: 'El año no puede ser menor a 1900' }
                    });
        register({ name: "rating" }, { required: 'El puntaje es lo más representativo de tu reseña.' });
        register({ name: "comment" }, { required: 'Este campo es obligatorio' });
        register({ name: "positive" }, { required: 'Este campo es obligatorio' } );
        register({ name: "negative" }, { required: 'Este campo es obligatorio' } );
        
        
        if (param_r2 && param_mod) {
            fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=info&mo=${param_mod}&r2=${param_r2}`)
                .then(res => res.json())
                .then(data => {         
                    let info = data.hits.hits[0]["_source"];                       
                    setRubroNombre({
                        gen: info.rubros.rubro2.sexo,
                        nombre: info.rubros.rubro2.rubro_singular
                    });
                    setMarcaNombre(info.marca.detalle);
                    setModeloNombre(info.modelo.detalle);
                                                            
                    if (data.userId && parseInt(data.userId) > 0) {     
                        setUserId(parseInt(data.userId));
                    } else {
                        // setLoginOpen(true);
                        // dl.push({
                        //     'ruta': '/login/formulario',
                        //     'titulo': 'AgroadsPrecios-Miembros-Acceso-Formulario',
                        //     'categoriaPagina': 'LoginFormulario',
                        //     'event': 'pvvLogin'
                        // })
                    }
                })
                .catch(console.log)

            fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=getimg&mo=${param_mod}&r2=${param_r2}`)
                .then(res => res.json())
                .then(data => {
                    let img_url = `${ STATIC_URL_1 }img/no-fotos-225x180.png`;
                    if (data.hits.hits && data.hits.hits[0])
                        img_url = `${STATIC_URL_2 }${data.hits.hits[0]["_source"].pictures[0].variants["100"].jpg}`                
                    
                    setTimeout(() => {
                        setRubroImg(img_url);                                            
                    }, 500);
                })
                .catch(console.log)
        }
    }, [])

    

    const handleLoginResult = (data) => {                
        setLoginResult(data);        
    }    

    const onSubmit = data => {    
        if (G_USER_ID === 0 && !loginResult) {
            setLoginOpen(true);   
            let dl = window.dataLayer;         
            dl.push({
                'ruta': '/login/formulario',
                'titulo': 'AgroadsReviews-Miembros-Acceso-Formulario',
                'categoriaPagina': 'LoginFormulario',
                'event': 'pvvLogin'
            })
            return false;
        }

        let i_urls = []
        setLoading(true);
        console.log("[Sending images...]");        


        let imgPromises = [];
        for (let index = 0; index < imagesToUpload.length; index++) {                        
            imgPromises.push(subirImagen(imagesToUpload[index]));
        }
        
        Promise.all(imgPromises)
            .then(uploaded_imgs => {
                console.log(uploaded_imgs);
                if (uploaded_imgs.length > 0) {
                    uploaded_imgs.forEach(img => {
                        if (img.estado==="ok")
                            i_urls.push(`${img.nombre}${img.ext}`);
                    });
                }            
                console.log("[Images uploaded]");
                
                // crear review.
                fetch('https://www.agroads.com.ar/reviews/api/es.asp', {
                    method: 'POST',                
                    credentials: 'same-origin',
                    body: `action=create&item_id=${param_mod}&valuation=${data.rating}&positive_comment=${encodeURI(data.positive)}&negative_comment=${encodeURI(data.negative)}&comment=${encodeURI(data.comment)}&year=${data.year}`,
                    headers: new Headers({
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    })
                })
                .then(res => res.json())
                .then(res => {
                    // si se cargaron imágenes, asociarlas.                    
                    // console.log("[imgs]", i_urls);
                    let respuesta = JSON.parse(res);

                    if (respuesta.id) {
                        if (i_urls.length > 0) {
                            fetch('https://www.agroads.com.ar/reviews/api/es.asp', {
                                method: 'POST',
                                credentials: 'same-origin',
                                body: `action=upload&review_id=${respuesta.id}&images=${encodeURI(i_urls.join(","))}`,
                                headers: new Headers({
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                                })
                            })
                            .then(r => r.json())
                            .then(rjson => {
                                props.history.replace(`/r/${param_r2}/modelo/${param_mod}/success`);
                                setLoading(false);
                            })
                            .catch(err => {
                                props.history.replace(`/r/${param_r2}/modelo/${param_mod}/success`);
                                setLoading(false);
                            })
                        }
                        else {
                            props.history.replace(`/r/${param_r2}/modelo/${param_mod}/success`);
                            setLoading(false);
                        }
                    }
                })
                .catch(e => {
                    console.log("Error", e);
                    enqueueSnackbar(`Error al cargar reseña`, { variant: 'error' })
                    setLoading(false);
                });                    
            }).catch(e => {
                enqueueSnackbar(`Error al cargar imágenes`, { variant: 'error' })
                setLoading(false);
        });            
    }
    
    var guid = (function () {
        var counter = 0;

        return function (prefix) {
            var guid = new Date().getTime().toString(32), i;

            for (i = 0; i < 5; i++) {
                guid += Math.floor(Math.random() * 65535).toString(32);
            }

            return (prefix || 'o_') + guid + (counter++).toString(32);
        };
    }());
    
   const subirImagen = (img) => {     
        // return a Promise
        console.log("subirImagen img:", img);
        let temp_name = guid();
        let ext = img.name.split('.').pop();
        let temp_filename = temp_name + '.' + ext;

        if (img) {
            let formData = new FormData();            
            formData.append("accion", "subirtemp");            
            formData.append("Filedata", img, temp_filename)
            formData.append("name", temp_filename);
            return new Promise((resolve,reject) => {
                fetch('https://django.agroads.com.ar/v1/files/clasificados/subir_temp/', {
                    method: 'POST',
                    body: formData
                })
                .then(res => res.json())
                .then(res => {                        
                    resolve(res);
                })
                .catch(e => {
                    reject(e)
                })
            })
        } else {
            return new Promise((resolve, reject) => reject("Falta imagen"))
        }
   }

    return (
        <Layout loading={loading}>            
            <Container maxWidth="lg" className={classes.Container}>                
                <Box display="flex" alignItems="center" className={classes.MainWrapper}>
                    
                    <Fade in={true} timeout={1600}>
                        <div className={classes.FormWrapper}>                            
                            <Typography variant='h6'>Calificar</Typography>
                            <Box>                                    
                                <div className={classes.ProductWrapper}>
                                    <div className={classes.ProductAvatar}>
                                        {
                                            rubroImg !== null ? <img alt="Imagen producto" src={`${rubroImg}`} /> : <Skeleton variant="circle" width={80} height={80} />
                                        }
                                    </div>
                                    <div className={classes.ProductInfo}>
                                        {/* <Typography className={classes.Title}><span className={classes.LightText}>{ rubro.nombre.toLowerCase() }</span> { marca } { modelo}</Typography> */}
                                        <Typography className={classes.Title}><span className={classes.LightText}>modelo</span> {marca} {modelo}</Typography>
                                    </div>
                                </div>                                                         
                            </Box>
                            

                            <form className={classes.Form} autoComplete="off" ref={refForForm}>
                                <Box mb={4}>
                                    <Typography className={classes.QuestionText}>¿Qué puntaje le das?</Typography>  
                                    <Box className={classes.RatingWrapper}>
                                        <Rating
                                            className={classes.RatingWidget}                                            
                                            onChange={(event, newValue) => {
                                                setValue('rating', newValue)
                                            }}
                                            size="large"
                                            precision={1}
                                            onChangeActive={(event, newHover) => {
                                                setHover(newHover);
                                            }}
                                        />
                                        {
                                            hover!== -1 || getValues("rating") > 0
                                                ? <Chip className={classes.ChipLabel} label={LABELS[hover !== -1 ? hover : getValues("rating")]} variant="outlined" />
                                            : null                                            
                                        }                                         
                                    </Box>
                                    
                                    
                                    {
                                        errors.rating 
                                        ? <Box mt={1}>
                                            <FormHelperText error>
                                                { errors.rating.message }
                                            </FormHelperText>
                                            </Box>
                                        : null
                                    }                                    
                                    
                                </Box>
                                
                                <Box mb={4}>     
                                    <Typography className={classes.QuestionText}>Contanos lo que sabés de este modelo</Typography>
                                    <TextField 
                                        variant='outlined' 
                                        multiline={true} 
                                        rows={5} 
                                        name='comment' 
                                        fullWidth 
                                        onChange={(e) => setValue('comment', e.target.value)} 
                                        error={errors.comment} 
                                        helperText={errors.comment?.message}
                                        placeholder='Detallá todo lo que te gustaría que las personas conozcan sobre este modelo'
                                        />   
                                        
                                </Box>
                                <Box mb={4}>     
                                        { rubro.gen !== '' 
                                            ? <Typography className={classes.QuestionText}>Lo mejor</Typography>
                                        :   <Skeleton variant="rect" width={350} height={10} style={{marginBottom: '20px'}}></Skeleton>
                                        }                                    
                                    <TextField 
                                        variant='outlined' 
                                        multiline={true} 
                                        rows={2} 
                                        name='positive'                                        
                                        fullWidth 
                                        onChange={(e) => setValue('positive', e.target.value)}
                                        error={errors.positive}
                                        helperText={errors.positive?.message}
                                        placeholder='¿Qué puntos destacarías de este modelo?'
                                        />
                                </Box>
                                <Box mb={4}>                                    
                                    <Typography className={classes.QuestionText}>Contras</Typography>
                                    <TextField 
                                        variant='outlined' 
                                        multiline={true} 
                                        rows={2} 
                                        name='negative'
                                        fullWidth 
                                        onChange={(e) => setValue('negative', e.target.value)}
                                        error={errors.negative}
                                        helperText={errors.negative?.message}
                                        placeholder='¿Tuviste algún problema recurrente? ¿En qué casos no lo recomendarías?'
                                        />
                                </Box>
                                <Box mb={4}>
                                    {rubro.gen !== ''
                                        ? <Typography className={classes.QuestionText}>Año {rubro.gen === 0 ? 'de la ' : 'del '}{rubro.nombre.toLowerCase()}</Typography>
                                        : <Skeleton variant="rect" width={350} height={10} style={{ marginBottom: '20px' }}></Skeleton>
                                    }
                                    <TextField
                                        inputProps={{
                                            maxLength: 4,
                                        }}
                                        variant='outlined'
                                        name='year'
                                        error={errors.year}
                                        onChange={(e) => setValue('year', e.target.value)}
                                        fullWidth
                                        helperText={errors.year?.message}
                                        placeholder='Ej. 2005'
                                    />
                                </Box>
                                
                                <Box mb={4}>
                                    <Box display='flex' alignItems='center' className={classes.QuestionText}>
                                        <span>Fotos</span>
                                        <Typography variant="body2" className={classes.QuestionTextExtra}>(Opcional)</Typography>
                                    </Box>
                                    <FilePond
                                        files={reviewImages}
                                        allowMultiple={true}
                                        onupdatefiles={fileItems => {
                                            setReviewImages(fileItems.map(f => f.file))
                                            let arr = fileItems.filter(f => f.status ===2).map(f2 => f2.file);
                                            setImagesToUpload(arr);
                                        }}
                                        credits={false}
                                        acceptedFileTypes={['image/png', 'image/jpeg']}
                                        labelFileTypeNotAllowed='Tipo de archivo no permitido.'
                                        maxFileSize='3000000'
                                        labelMaxFileSizeExceeded='Tamaño de archivo muy grande.'
                                        labelIdle='Agregar <span class="filepond--label-action">fotos</span> de mi equipo'
                                        imageValidateSizeMinWidth='360'
                                        imageValidateSizeMinHeight='288'
                                        imageValidateSizeMaxWidth='1920'
                                        imageValidateSizeMaxHeight='1080'
                                        imageValidateSizeLabelExpectedMinSize={`Tamaño mínimo: {minWidth}x{minHeight}px`}
                                        imageValidateSizeLabelExpectedMaxSize={`Tamaño máximo: {minWidth}x{minHeight}px`}
                                        imageValidateSizeLabelImageSizeTooSmall='Imagen muy chica'
                                        imageValidateSizeLabelImageSizeTooBig='Imagen muy grande'
                                    />                                   
                                </Box>
                            

                                <div className={classes.ActionsWrapper}>
                                    {
                                        G_USER_ID > 0
                                            ? <Button variant='contained' color='primary' className={classes.SubmitBtn} onClick={handleSubmit(onSubmit)} disabled={loading}>Calificar</Button>
                                            : <Button variant='contained' color='primary' className={classes.SubmitBtn} onClick={handleSubmit(onSubmit)} disabled={loading}>Identificarme y calificar</Button>
                                    }                                    
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Box>
            </Container>
            <LoginModal isOpen={loginOpen} callback={handleLoginResult}/>
        </Layout>
    )
}

export default ReviewForm;